<span [innerHTML]="priceHTML | safeHtml"></span>
